// components/booking/utils/priceHelpers.js
import { timeToHour } from "./dateTimeHelpers";

export const calculateSlotPrice = (slot, space) => {
  const duration = timeToHour(slot.to) - timeToHour(slot.from);
  
  let pricePerHour = space.hourly_rate || 0;
  let pricePerDay = space.daily_rate || 0;
  
  if (duration >= 8) {
    return pricePerDay * Math.floor(duration / 8);
  } else if (duration >= 4) {
    return (pricePerDay / 2) * Math.floor(duration / 4);
  } else {
    return pricePerHour * duration;
  }
};

export const calculateTotalPrice = (bookingHours, services = [], space) => {
  const bookingTotal = bookingHours.reduce((total, slot) => {
    return total + calculateSlotPrice(slot, space);
  }, 0);
  
  const servicesTotal = services.reduce((total, service) => {
    return total + (service.price * service.quantity);
  }, 0);
  
  return bookingTotal + servicesTotal;
};

export const calculateVAT = (amount, vatRate = 0.2) => {
  return amount * vatRate;
};

export const formatPrice = (amount, currency = "EUR") => {
  const symbols = { EUR: "€", USD: "$", GBP: "£" };
  const symbol = symbols[currency] || "€";
  return `${amount.toFixed(2)} ${symbol}`;
};

export const currencyToSymbol = (currency) => {
  const symbols = { EUR: "€", USD: "$", GBP: "£" };
  return symbols[currency] || "€";
};